
export function estimateSecondsRemaining(startTime: number, uploadedBytes: number, totalBytes: number): number | null {
  if (!startTime || uploadedBytes === 0) return null;
  const elapsedTime = (Date.now() - startTime) / 1000; // in seconds
  const uploadRate = uploadedBytes / elapsedTime; // bytes per second
  const remainingBytes = totalBytes - uploadedBytes;
  return uploadRate > 0 ? Math.round(remainingBytes / uploadRate) : null; // in seconds
};

export const getFileNameSansFolder = (file: File, folderName: string): string => {
  return file.webkitRelativePath ?
    file.webkitRelativePath.replace(folderName, '') :
    file.name;
};

export const getTargetFilePathForLocalFile = (subFolder: string, file: File, folderName: string): string => {
  return subFolder ?
    `${subFolder}/${getFileNameSansFolder(file, folderName)}`.replace(/^\/+/, '') : // Remove leading slashes
    getFileNameSansFolder(file, folderName);
};
